<template>
    <div class="cont-pro-box">
        <!-- 概览 -->
        <div v-if="props.type == 'index'" class="cont-pro-index">
            <div v-if="state.pro_info && state.pro_info.tip" class="pro_tips">
                <span class="icon-info2"></span>
                <p>{{state.pro_info.tip}}</p>
            </div>
            <div class="cont-pro">
                <img :class="['img', {'cursor': state.canGoInfo}]" @click="goProInfo" :src="$imgUrlFilter(state.pro_info.wb_logo_1 || state.pro_info.logo || 'https://s.moimg.net/m/img/placeholder/default_1x1@2x.png', 200, 200)" />
                <div class="pro">
                    <div :class="['pro-name', {'cursor': state.canGoInfo}]" @click="goProInfo">{{ state.pro_info.title || state.pro_info.name }}</div>
                    <div class="pro-info">
                        <div class="item" v-if="state.pro_info.id">
                            <span>项目ID</span>
                            <div>{{ state.pro_info.id }}</div>
                        </div>
                        <div class="item">
                            <span>类型</span>
                            <div>{{ state.pro_info.category }}</div>
                        </div>
                        <div class="item">
                            <span>状态</span>
                            <div>{{ state.pro_info.status_desc || state.pro_info.status }}</div>
                        </div>
                        <div class="item">
                            <span>众筹周期</span>
                            <div>{{ state.start_time }} 至 {{  state.end_time }}</div>
                        </div>
                    </div>
                    <div class="pro-actions">
                        <template v-for="(item, index) in props.actions" :key="index">
                            <el-button 
                                :type="state.actionsGreenMap[item.action_type] ? 'primary' : ''"
                                :data-type="item.action_type"
                                @click="onAction(item)"
                                >{{ item.action_name }}</el-button>
                        </template>
                        <el-button v-if="state.advertisingEnabled" @click="handleAdvertisingAction()">申请站外免费资源</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 数据分析模块 -->
        <div v-else-if="props.type == 'analysis'" class="cont-pro-analysis">
            <div class="cont-pro">
                <img class="img" :src="$imgUrlFilter(state.pro_info.logo || 'https://s.moimg.net/m/img/placeholder/default_1x1@2x.png', 200, 200)" />
                <div class="pro">
                    <div class="pro-name">{{ state.pro_info.title || state.pro_info.name }}</div>
                    <div class="pro-time">
                        <span>众筹周期</span>
                        <div>{{ state.start_time }} 至 {{  state.end_time }}</div>
                    </div>
                </div>
            </div>
            <div class="cont-pro-analysis-data">
                <GridList width="200">
                    <div class="data-li">
                        <div class="icon-crowdfunding icon"></div>
                        <div class="data">
                            <strong>￥{{ tools.fmoney(state.pro_info.backer_money) }}</strong>
                            <span>众筹金额</span>
                        </div>
                    </div>
                    <div class="data-li">
                        <div class="icon-portion icon"></div>
                        <div class="data">
                            <strong>{{ tools.fmoney(state.pro_info.progress) }}%</strong>
                            <span>完成进度</span>
                        </div>
                    </div>
                    <div class="data-li">
                        <div class=" icon-person icon"></div>
                        <div class="data">
                            <strong>{{ tools.fmoney(state.pro_info.backer_count) }}</strong>
                            <span>支持人数</span>
                        </div>
                    </div>
                    <div class="data-li">
                        <div class=" icon-money icon"></div>
                        <div class="data">
                            <strong>￥{{ tools.fmoney((state.pro_info.backer_count > 0 ? state.pro_info.backer_money / state.pro_info.backer_count : state.pro_info.backer_count), 2) }}</strong>
                            <span>人均金额</span>
                        </div>
                    </div>
                </GridList>
            </div>
        </div>
        <div v-else class="cont-pro">
            <img class="img" :src="$imgUrlFilter(state.pro_info.logo || 'https://s.moimg.net/m/img/placeholder/default_1x1@2x.png', 200, 200)" />
            <div class="pro">
                <div class="pro-name">{{ state.pro_info.title || state.pro_info.name }}</div>
                <div class="pro-item">
                    <label>项目ID</label>
                    <div>{{ state.pro_info.id }}</div>
                </div>
                <div class="pro-item">
                    <label>状态</label>
                    <div>{{ state.pro_info.status_desc }}</div>
                </div>
            </div>
        </div>
        <el-drawer 
            v-model="state.drawer" 
            :title="state.drawerTit"
            size="600px"
            :closeOnClickModal="false"
            @close="initDrawer">
            <div class="drawer-info">
                <template v-if="state.drawerType == 'modify_opinion' || state.drawerType == 'reject_reason'">
                    <div v-html="state.drawerInfo"></div>
                </template>
                <template v-else>
                    <div class="cancel_field">
                        <p v-if="state.action_type == 'cancel'">1.粘贴项目更新链接（含有众筹取消原因的更新链接）</p>
                        <p v-if="state.action_type == 'extend'">1.粘贴项目更新链接（含有延长众筹期原因的更新链接）</p>
                        <p v-if="state.action_type == 'ahead'">1.粘贴项目更新链接（含有申请提前结束众筹原因的更新链接）</p>
                        <div class="input_border">
                            <input type="text" v-model="state.update_url" placeholder="请粘贴项目更新链接" />
                        </div>
                        <div v-if="state.update_title" class="update_title">更新标题：{{state.update_title}}</div>
                        <template v-if="state.action_type == 'cancel'">
                            <p class="tips">• 请先与摩点运营人员沟通<template v-if="state.drawerType == 'cancel01'">，并提供能够证明该项目无法如约交付的响应的证据文件；</template></p>
                            <p class="tips">• 沟通确认后，需发布项目更新，告知支持者众筹取消的原因。<a href="https://www.modian.com/project/update/detail/110982" target="_blank">示例</a></p>
                        </template>
                        <template v-if="state.action_type == 'extend'">
                            <p class="tips">• 请先与摩点运营人员沟通</p>
                            <p class="tips">• 沟通确认后，需发布项目更新，告知支持者延长众筹期的原因及结束时间，<a href="https://www.modian.com/project/update/detail/140451" target="_blank">示例</a></p>
                        </template>
                        <template v-if="state.action_type == 'ahead'">
                            <p class="tips">• 请先与摩点运营人员沟通</p>
                            <p class="tips">• 沟通确认后，需发布项目更新，告知支持者提前结束众筹的原因及结束时间，<a href="https://www.modian.com/project/update/detail/141477" target="_blank">示例</a></p>
                        </template>
                        <p v-if="state.action_type == 'cancel'" style="padding-top:13px;">2.众筹取消后，所有款项将退款给支持者</p>
                        <p v-if="state.action_type == 'extend'" style="padding-top:13px;">2.延长众筹结束时间（原结束时间 <span>{{state.end_time}}</span>）</p>
                        <p v-if="state.action_type == 'ahead'" style="padding-top:13px;">2.众筹提前结束时间（原结束时间 <span>{{state.end_time}}</span>）</p>
                        <!-- 达到众筹目标 -->
                        <p v-if="state.action_type == 'cancel' && state.drawerType == 'cancel01'" class="tips" style="padding-top:4px;">请注意：根据《发起者协议》第5.7条，摩点审核同意取消众筹后，自取消众筹之日起3个月内，您及其关联方、合作方不得在任何其他电商销售渠道（包括但不限于有赞商城、京东商城、淘宝店铺、微店、B站、微信群组等）或者线下门店渠道对本项目主要回报产品进行销售，否则您应自违约之日起5个工作日内向摩点支付项目募集总金额的 <span>20%作为违约金</span>；</p>
                        <div v-if="['extend','ahead'].includes(state.action_type)" class="time">
                            <p v-if="state.action_type == 'extend'">延长结束时间至</p>
                            <p v-else>提前结束时间至</p>
                            <div class="input hour">
                                <!-- :disabled-date="releaseDisabled" -->
                                <el-date-picker
                                    :editable="false"
                                    :default-value="defaultTime"
                                    type="date"
                                    format="YYYY-MM-DD"
                                    value-format="YYYY-MM-DD"
                                    v-model="state.time_year"
                                    placeholder="请选择日期"
                                />
                                <span class="icon_down">
                                    <i class="iconfont icon-date"></i>
                                </span>
                            </div>
                            <div class="input hour">
                                <el-time-picker
                                    :editable="false"
                                    format="HH:mm"
                                    value-format="HH:mm"
                                    v-model="state.time_hour"
                                    placeholder="请选择时间"
                                />
                                <span class="icon_down">
                                    <i class="iconfont icon-wait"></i>
                                </span>
                            </div>
                        </div>
                        <p v-if="state.action_type == 'extend'" class="tips">众筹时间不超过90天，延期不影响原定发货时间</p>
                        <p v-if="state.action_type == 'ahead' && state.update_release_time" class="tips">请设置在 <span>{{state.update_release_time}}</span> 之后，因审核要求需距发布提前结束的更新至少48小时，</p>
                    </div>
                </template>
            </div>
            <template #footer>
                <el-button 
                    v-if="state.drawerType == 'modify_opinion' || state.drawerType == 'reject_reason'" type="primary" 
                    @click="state.drawer=false">确认</el-button>
                <template v-else>
                    <el-button @click="state.drawer=false">暂不申请</el-button>
                    <el-button v-if="state.action_type == 'cancel'" type="primary" @click="cancelPro">申请取消众筹</el-button>
                    <el-button v-if="state.action_type == 'extend'" type="primary" @click="editSaleTime('extend')">申请延长众筹</el-button>
                    <el-button v-if="state.action_type == 'ahead'" type="primary" @click="editSaleTime('ahead')">申请提前结束众筹</el-button>
                </template>
            </template>
        </el-drawer>
        <el-dialog v-model="state.qrcodeVisible" title="申请站位免费资源" :width="420">
            <div class="qrcode">
                <span class="title">
                    即刻添加「站外免费资源申请」企业微信，解锁站外推广福利！<br>提交商品素材即可免费申领官号曝光资源，优质内容额外获得千万级流量扶持！
                </span>
                 <el-image class="icon"
                    src="https://p6.moimg.net/mdwxapp/ad_wx_logo.png"
                    :fit="fit"></el-image>
                <span class="des">扫描二维码，添加运营企微</span>
            </div>
        </el-dialog>
    </div>
</template>
<script setup>
import { ElMessage } from "element-plus";

import domain from '@/service/domain'
import { reactive, computed, watch, defineProps, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from 'vuex'
import { checkProjectCancel, CancelProject, DelProject, getPreviewToken, getCpUpdateDetail, EditProSellingTime, ProConvertIdea, ProConvertWish, getRejectReason, getShopId } from "@/api/index"
import tools from '@/utils/tools.js'
import GridList from "@@/common/gridList.vue";
// import { fa } from "element-plus/es/locale/index.mjs";

const route = useRoute();
const router = useRouter();
const store = useStore()
const props = defineProps(['type', 'actions'])
const state = reactive({
    actionsGreenMap: {
        'edit': true,
        'reject_reason': true,
        'modify_opinion': true,
        'release_pro': true
    },
    drawerType: '',
    drawerTit: '',
    drawerInfo: '',
    cancel_reason: '', // 取消原因
    update_url: '', // 更新链接
    update_title: '',
    action_type: '',
    time_year: '',
    time_hour: '',
    update_release_time: '',
    qrcodeVisible: false
})
const initDrawer = () => {
    state.update_url = '';
    state.update_title = '';
    state.time_year = '';
    state.time_hour = '';
    state.update_release_time = '';
}
state.userId = computed(() => {
    return store.state.user.user_id
})
state.pro_id = computed(() => {
    return route.params.id || ''
})
state.pro_info = computed(() => {
    return store.state.project.proInfo ? store.state.project.proInfo.info : {}
})
state.isTemp = computed(() => {
    return state.pro_info.status_code == -3 || false
})

state.isWds = computed(() => {
    return state.pro_info.id && state.pro_info.pro_class == '201'
})

state.canGoInfo= computed(() => {
    return [0, 1, 2, 3, 6, 7].includes(state.pro_info.status_code) && state.pro_id
})
//站外推广
state.advertisingEnabled = computed(() => {
    // 众筹中，且众筹类型为众筹，且众筹金额大于等于众筹目标
    return state.pro_info.status_code == 0 && state.pro_info.pro_class == '101' && Number(state.pro_info.backer_money) >=  Number(state.pro_info.goal)
})
// 更新ID
state.updateId = computed(() => {
    const url = state.update_url;
    const pattern = /\/detail\/(\d+)$/;
    const match = url.match(pattern);
    let update_id = '';
    if (match) {
        update_id = match[1];
        console.log("提取到的项目 ID 为：" + update_id);
    } else {
        update_id = '';
    }
    return update_id;
})
watch(() => {state.updateId}, () => {
    if(state.updateId){
        getCpUpdateDetail({update_id:state.updateId}).then(res => {
            if(res.status == 0){
                state.update_title = res.data.title;
                
                state.update_release_time = proxy.$dayjs(res.data.release_time).add(48, 'hour').format('YYYY-MM-DD HH:mm');
            }else{
                state.update_title = '';
                state.update_release_time = '';
                tools.confirm(res.message);
            }
        })
    }
}, { deep: true, immediate: true })
const { proxy } = getCurrentInstance()
state.start_time = computed(() => {
    if (state.pro_info.start_time == '0001-01-01 00:00:00' || !state.pro_info.start_time) {
        return '--'
    } else {
        return proxy.$dayjs(state.pro_info.start_time).format('YYYY-MM-DD HH:mm')
    }
})
state.end_time = computed(() => {
    if (state.pro_info.end_time == '0001-01-01 00:00:00'  || !state.pro_info.end_time) {
        return '--'
    } else {
        return proxy.$dayjs(state.pro_info.end_time).format('YYYY-MM-DD HH:mm')
    }
})

const defaultTime = new Date(+new Date(proxy.$dayjs(state.pro_info.end_time).format('YYYY-MM-DD')) + 1 * 60 * 60 * 1000);
// console.log(defaultTime)
// const releaseDisabled = time => {
//     return time > new Date(proxy.$dayjs(state.pro_info.end_time).format('YYYY-MM-DD'))
// }
// const aheadDisabled = time => {
//     return time < new Date(proxy.$dayjs(state.pro_info.end_time).format('YYYY-MM-DD'))
// }
// 检测是否可取消众筹
const checkCancel = () => {
    checkProjectCancel({
        user_id: state.userId,
        pro_id: state.pro_id
    }).then(res => {
        if (res.status == 0) {
            state.drawerTit = '确定申请众筹取消吗？'
            state.drawer = true
        } else {
            ElMessage({
                type: 'warning',
                customClass: 'waring-customize',
                message: res.message || '无法取消',
            });
        }
    })
}
// 
const editSaleTime = (edit_type) => {
    if(!state.time_year || !state.time_hour){
        ElMessage({
            type: 'warning',
            customClass: 'waring-customize',
            message: '请选择日期和时间',
        });
        return false;
    }
    if (state.update_url){
        EditProSellingTime({
            pro_id: state.pro_id,
            update_url: state.update_url,
            edit_type: edit_type,
            end_time: state.time_year+' '+state.time_hour+ ':00'
        }).then(res => {
            if(res.status == 0){
                tools.confirm({
                    msg: '您的申请已提交，结果请留意通知'
                },() => {
                    location.reload();
                })
            }else{
                ElMessage({
                    type: 'warning',
                    customClass: 'waring-customize',
                    message: res.message,
                })
            }
        })
    } else {
        ElMessage({
            type: 'warning',
            customClass: 'waring-customize',
            message: '请粘贴项目更新链接',
        });
    }
}
// 取消众筹
const cancelPro = () => {
    if (state.update_url){
        CancelProject({
            pro_id: state.pro_id,
            update_url: state.update_url
        }).then(res => {
            var status = parseInt(res.status);
            switch (status) {
                case 1:
                    tools.confirm({
                        msg: '您的取消众筹申请已提交，结果请留意通知'
                    },() => {
                        location.reload();
                    })
                    break;
                case -2:
                    location.href = domain.account;
                    break;
                case -3:
                    ElMessage({
                        type: 'warning',
                        customClass: 'waring-customize',
                        message: res.message,
                    })
                    break;
            }
        })
    } else {
        ElMessage({
            type: 'warning',
            customClass: 'waring-customize',
            message: '请粘贴项目更新链接',
        });
    }
}
// 删除项目
const delPro = () => {
    let obj = {}
    if (state.pro_info.temp_id) {
        obj = {
            temp_id: state.pro_info.temp_id
        }
    } else {
        obj = {
            pro_id: state.pro_id
        }
    }
    DelProject(obj).then(res => {
        var status = parseInt(res.status);
        switch (status) {
            case 1:
                tools.confirm({
                    msg: res.message
                },() => {
                    location.reload();
                })
                break;
            case - 2:
                location.href = domain.account;
                break;
            case - 3:
                ElMessage({
                    type: 'warning',
                    customClass: 'waring-customize',
                    message: res.message,
                })
                break;
        }
    })
}
// 预览项目
const previewPro = () => {
    getPreviewToken({
        pro_id: state.pro_id || 0,
        temp_id: state.pro_info.temp_id || 0
    }).then(res => {
        if (res.status == 0 && res.data.token) {
            window.open(`${domain.zhongchou}/p/project_preview_cp?token=${res.data.token}&temp_id=${state.pro_info.temp_id || 0}&id=${state.pro_id || 0}`)
        }
    })
}
const onAction = (item) => {
    console.log('item', item)
    // 如果是微打赏项目的操作，除了编辑项目资料，都跳转至旧的后台
    if (state.isWds && item.action_type == 'goOld') {
        return window.open(`${domain.zhongchou}/project_new_wds/pro_cover?id=${state.pro_id}`)
    }
    state.action_type = item.action_type;
    switch(item.action_type) {
        case 'edit': // 编辑项目资料
            if (state.isWds) {
                window.open(`${domain.member}/initiate/base?id=${state.pro_id}`)
            } else if (state.pro_info.temp_id) {
                window.open(`${domain.account}/initiate/base?pro_id=0&temp_id=${state.pro_info.temp_id}`)
            } else {
                window.open(`${domain.account}/initiate/base?pro_id=${state.pro_id}`)
            }
            break;
        case 'supplement': // 补充资质
            router.push(`/project_manage/supplemental_agreement/${state.pro_id}`)
            break;
        case 'release_pro': // 项目更新
            window.open(`${domain.account}/initiate/publish?pro_id=${state.pro_id}`)
            break;
        case 'delete': // 删除项目
            tools.confirm({
                title:'提示',
                hasCancel: true,
                cancel:'再想想',
                success:'删除',
                msg: '确定删除该项目吗？删除后无法恢复！'
            },() => {
                delPro()
            })
            break;
        case 'extend': // 延长众筹
            state.drawerTit = '确定申请延长众筹吗？'
            state.drawer = true;
        break;
        case 'ahead': // 提前结束
            state.drawerTit = '确定申请提前结束众筹吗？'
            state.drawer = true;
        break;
        case 'cancel': // 申请取消众筹
            // state.drawerType = state.pro_info.progress == '100%' ? 'cancel01' : 'cancel02'
            state.drawerType = Number(state.pro_info.backer_money) > Number(state.pro_info.goal) ? 'cancel01' : 'cancel02'
            checkCancel()
            break;
        case 'release_update': // 项目更新
            router.push(`/project_manage/update/index/${state.pro_id}`)
            break;
        // 审核进度 --- start
        case 'reject_reason': // 查看拒绝原因
        case 'modify_opinion': // 查看修改意见
        case 'review': // 审核中
            if(state.pro_info.category == '个人愿望'){
                getRejectReason({
                    pro_id: state.pro_id,
                    type:'crowdfunding'
                }).then(res => {
                    tools.confirm({
                        hasCancel:false,
                        dangerouslyUseHTMLString:true,
                        success:'确定',
                        msg: res.data.content
                    }, () => {})
                })
            }else{
                window.open(`${domain.account}/initiate/result?pro_id=${state.pro_id}&type=${item.action_type}`)
            }
            break;
        // 审核进度 --- end
        case 'convert_idea': // 转创意
            tools.confirm({
                hasCancel:true,
                cancel:'取消',
                success:'确定',
                msg: '确定要转创意吗？创意期间支持转众筹'
            }, () => {
                ProConvertIdea ({
                    pro_id: state.pro_id,
                }).then(({status, data, message}) => {
                    if (status == 0 && data && data.idea_id) {
                        window.open(`${domain.member}/initiate/idea_edit?idea_id=${data.idea_id}`)
                    } else {
                        ElMessage({
                            type: 'warning',
                            customClass: 'waring-customize',
                            message: message,
                        });
                    }
                })
            })
            break;
        case 'convert_mall': // 转电商
            tools.confirm({
                hasCancel:true,
                cancel:'取消',
                success:'确定',
                msg: '确定要转电商吗？'
            }, () => {
                handleMallAction()
            })
            break;
        case 'edit_goods': // 编辑商品
            handleMallAction()
            break;
        case 'convert_wish': // 转个人愿望
            tools.confirm({
                hasCancel:true,
                cancel:'取消',
                success:'确定',
                msg: '确定要转个人愿望吗？'
            }, () => {
                ProConvertWish ({
                    pro_id: state.pro_id,
                }).then(({status, message}) => {
                    if (status == 0) {
                        window.location.reload();
                    } else {
                        ElMessage({
                            type: 'warning',
                            customClass: 'waring-customize',
                            message: message,
                        });
                    }
                })
            })
            break;
        case 'preview': // 项目预览
            previewPro()
            break;
        case 'settlement': // 查看结算单
            router.push(`/project_manage/settlement/index/${state.pro_id}`)
            break;
        case 'shipping': // 批量发货
            router.push(`/project_manage/deliver/${state.pro_id}`)
            break;
        case 'submit_verify': // 提交审核
            console.log('Action: submit_verify（提交审核）', item);
            // 在这里添加实际的逻辑
            break;
        case 'end_pro': // 结束项目
            console.log('Action: end_pro（结束项目）', item);
            // 在这里添加实际的逻辑
            break;
        case 'cash_out':  // 提现
            console.log('Action: cash_out（提现）', item);
            // 在这里添加实际的逻辑
            break;
        case 'refund': // 退款
            console.log('Action: refund（退款）', item);
            // 在这里添加实际的逻辑
            break;
        case 'cash_out_record': // 提现单据
            console.log('Action: cash_out_record（提现单据）', item);
            // 在这里添加实际的逻辑
            break;
        case 'edit_pro_time': // 修改众筹时间
            console.log('Action: edit_pro_time（修改众筹时间）', item);
            // 在这里添加实际的逻辑
            break;
    }
}

const handleMallAction = () => {
    getShopId({
        product_id: state.pro_id
    }).then(res => {
        if(res.status == 0){
            if(res.data && res.data.shop_id){
                if(res.data.product_id){
                    window.open(`${domain.center}/product/goods/add?product_id=${res.data.product_id}`)
                }else{
                    window.open(`${domain.center}/product/goods/add?item_id=${state.pro_id}&is_show=${state.pro_info.status_code == 3 ? 1 : 0}`)
                }
            }else{
                window.open(`${domain.center}/ucenter/joinshop/flow?item_id=${state.pro_id}&is_show=${state.pro_info.status_code == 3 ? 1 : 0}`)
            }
        }else{
            ElMessage({
                type: 'warning',
                customClass: 'waring-customize',
                message: res.message,
            });
        }
    })
}
//点击站外推广
const handleAdvertisingAction = () => {

    state.qrcodeVisible = true;
    /*
    if (state.pro_info.backer_money && Number(state.pro_info.backer_money) > 30000) {
        //金额大于10w才允许申请
        state.qrcodeVisible = true;
    } else {
        
        tools.confirm({
                title:'提示',
                hasCancel: true,
                success:'好的',
                msg: '众筹项目的筹资金额达3万时将开启站外推广，当前项目还未达到开启条件'
            },() => {
            })
    }
    */
    
}

// 去项目详情
const goProInfo = () => {
    if (state.canGoInfo) {
        window.open(`${domain.zhongchou}/item/${state.pro_id}`)
    }
}
</script>
<style lang="scss" scoped>
.cont-pro-box {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 20px;
}
.cont-pro {
    display: flex;
    align-items: center;
    height: 94px;
    .img {
        width: 94px;
        height: 94px;
        border-radius: 4px;
        border: 1px solid #F2F2F2;
        margin-right: 20px;
    }
    .pro {
        line-height: 1;
        flex: 1;
        width: 0;
        .pro-name {
            height: 20px;
            max-width: 100%;
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .pro-item {
            float: left;
            margin-right: 30px;
            label {
                font-size: 12px;
                color: #7F7F7F;
                margin-bottom: 6px;
            }
            div {
                font-size: 16px;   
            }
        }
        // 时间
        .pro-time {
            line-height: 1;
            span {
                font-size: 12px;
                color: #7F7F7F;
            }
            div {
                padding-top: 6px;
                font-size: 16px;
            }
        }
    }
}
.cont-pro-analysis-data {
    display: flex;
    margin-top: 20px;
    padding: 40px 0 20px;
    border-top: 1px solid #E8E8E8;
    .data-li {
        display: flex;
        align-items: center;
        .icon {
            width: 42px;
            height: 42px;
            background: #F8F8F8;
            border-radius: 50%;
            text-align: center;
            line-height: 42px;
            font-size: 22px;
            color: #7F7F7F;
            margin-right: 10px;
        }
        .data {
            display: flex;
            flex-direction: column;
            justify-content: center;
            strong {
                font-size: 18px;
            }
        }
    }
}
.cont-pro-index{
    .pro_tips{
        padding:0 15px;
        width: 100%;
        height: 48px;
        background: #FFF8EE;
        border-radius: 4px 4px 4px 4px;
        display:flex;
        align-items:center;
        margin: 0 0 20px 0;
        span{
            padding-right:6px;
            font-size:18px;
            color: #F5A728;
        }
        p{
            font-weight: 400;
            font-size: 16px;
            color: #F5A728;
            line-height: 16px;
        }
    }
    .cont-pro {
        height: 154px;
        .img {
            width: 154px;
            height: 154px;
        }
        .pro-info {
            display: flex;
            height: 56px;
            .item {
                margin-right: 30px;
                margin-bottom: 20px;
                span {
                    font-size: 12px;
                    color: #7F7F7F;
                }
                div {
                    font-size: 16px;
                    padding-top: 6px;
                }
            }
        }
        .pro-actions {
            height: 40px;
        }
    }
}
.drawer-info {
    strong {
        display: block;
        margin-bottom: 6px;
        &.tit {
            margin-top: 10px;
        }
    }
    .cancel_field{
        padding: 5px 0 0 0;
        .input_border{
            margin: 7px 0 10px 0;
            width: 100%;
            height: 36px;
            line-height: 36px;
            position: relative;
            cursor: pointer;
            input{
                display: block;
                width: 100%;
                height: 100%;
                border: 1px solid #DEE0E1;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding: 0 10px;
                font-size: 14px;
                outline: none;
                &:hover{
                    border: 1px solid #7A8087;
                }
            }
        }
        .update_title{
            width: 560px;
            height: 33px;
            background: #F2F2F2;
            border-radius: 4px;
            padding: 0 10px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 400;
            color: #7F7F7F;
            line-height: 33px;
            position: relative;
            margin: -2px 0 7px 0;
            &::after{
                content:'';
                position: absolute;
                top: -8px;
                left:20px;
                width: 0;
                height: 0;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                border-bottom: 8px solid #F2F2F2;
            }
        }
        >p{
            font-size: 14px;
            font-weight: 400;
            color: #1A1A1A;
            line-height: 21px;
            span{
                color:#F5A728;
            }
            &.tips{
                font-size: 12px;
                color: #7F7F7F;
                line-height: 18px;
                a{
                    color:#00C4A1;
                }
            }
        }
        .time{
            display: flex;
            align-items: center;
            .input{
                width:160px;
                margin: 8px 0 10px 10px;
                height: 40px;
                line-height: 40px;
                position: relative;
                cursor: pointer;
                &.hour{
                    border: 1px solid #E8E8E8;
                    border-radius: 4px;
                    box-sizing: border-box;
                    ::v-deep(.el-date-editor){
                        width: 100%;
                        height: 100%;
                        display: block;
                        .el-input__wrapper{
                            width: 100%;
                            height: 100%;
                            padding: 0;
                            box-shadow: none;
                            border-radius: 4px;
                        }
                        .el-input__inner{
                            border: 0;
                            padding: 0 10px !important;
                            line-height: 40px;
                            font-size: 14px;
                            height: 100%;
                            display: block;
                        }
                        .el-input__prefix,.el-input__suffix{
                            display: none;
                        }
                    }
                }
                .icon_down{
                    position: absolute;
                    top: 50%;
                    right: 11px;
                    transform: translateY(-50%);
                    color: #7a8087;
                    pointer-events: none;
                }
            }
        }
    }
}
.cursor {
    cursor: pointer; 
}
::v-deep(.el-dialog){
        .el-dialog__header{
            height:60px;
            padding:0;
            margin: 0 30px;
            font-size: 20px;
            font-weight: 600;
            line-height: 60px;
            color: #1A1A1A;
            border-bottom: 1px solid #E8E8E8;
        }
        .el-dialog__body{
            padding:20px 30px;
            .content{
                >p{
                    padding-top:10px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #1A1A1A;
                    line-height: 24px;
                }
            }
            .qrcode{
                display:flex;
                align-items:center;
                flex-direction:column;
                justify-content: space-between;
                color: #1A1A1A;
                #QrUpdateCode{
                    display:flex;
                    justify-content:center;
                    width: 200px;
                    height: 200px;
                }

                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                .icon {
                    width: 120px;
                    height: 120px;
                    margin: 10px 0;
                }
            }
        }
        .el-dialog__footer{
            .dialog-footer{
                display:flex;
                align-items:center;
                justify-content: end;
            }
        }
    }
</style>
